/**
 * Helper function to get handy type completion when writing your hooks,
 * put this as the default export in a `vue.setup.ts` file in your project root:
 *
 * ```ts
 * export default defineGlobalHooks({
 *   setupVue ({ app }) {
 *     console.log('I have created horrors behind your worst comprehensions, also I\'ve set up Pinia for you')
 *   }
 * })
 * ```
 */
export function defineGlobalHooks(hooks) { return hooks; }
/**
 * Loads the vue.setup.{js,ts} file, resolves .default or not, and returns the
 * object of hooks
 */
export async function getGlobalHooks() {
    try {
        // @ts-expect-error The path exists when vite resolve it relative to its root
        const module = await import('/vue.setup');
        return module?.default ?? module ?? {};
    }
    catch (err) {
        if (err instanceof Error && 'code' in err && err.code === 'ERR_LOAD_URL') {
            return {};
        }
        throw err;
    }
}
//# sourceMappingURL=setup-hooks.js.map